import { render, staticRenderFns } from "./w12.vue?vue&type=template&id=99594a78&scoped=true"
import script from "./w12.vue?vue&type=script&lang=js"
export * from "./w12.vue?vue&type=script&lang=js"
import style0 from "./w12.vue?vue&type=style&index=0&id=99594a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99594a78",
  null
  
)

export default component.exports